import { createContext, useContext } from "react";
import type { Application, Onboarding, ProfileView, Stats } from "../../shared/types.ts";
import type { ToastLink } from "../ui/Toaster.tsx";

export type Tone = "ok" | "bad" | "plain";

export interface AppCtx {
  user: { id: string; email: string };
  stats: Stats | null;
  goal: number;
  profile: ProfileView | null;
  onboarding: Onboarding | null;
  setProfile: (p: ProfileView) => void;
  refreshStats: () => void;
  /** Counts an apply straight away, as sending when Headcount sends it, and celebrates milestones from `from`. */
  applied: (from?: Element | null, auto?: boolean) => void;
  /** Takes back what `applied` counted. */
  unapplied: (auto?: boolean) => void;
  /** Applications that stopped on something only the user can give, as `waitsOnYou` filters them. */
  needs: Application[];
  /** Drops one from `needs` once its answers went out. */
  needsSent: (jobId: string) => void;
  /** Opens the Needs you sheet from anywhere. */
  showNeeds: () => void;
  toast: (text: string, tone?: Tone, link?: ToastLink) => void;
  signOut: () => void;
}

export const Ctx = createContext<AppCtx | null>(null);

export function useApp(): AppCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error("useApp outside provider");
  return c;
}

/** Tells screens that list applications to load them again. */
export const changed = () => dispatchEvent(new CustomEvent("engine-event"));
